import { motion } from 'motion/react'
import ActionButton from 'src/components/ActionButton'
import Picture from 'src/components/Picture'
import RichText from 'src/components/RichText'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

export const Container = styled(motion.section)`
  position: relative;
  display: grid;
  grid-template-columns: ${pxToRem(16)} 1fr;
  grid-template-rows: auto auto auto auto;
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    grid-template-columns: ${pxToRem(32)} 1fr 28vw;
  }
`

export const PictureWrapper = styled.div<{ $color?: string }>`
  position: relative;
  z-index: 2;
  grid-column: 1 / span 2;
  grid-row: 1 / span 2;
  background-color: ${({ $color }) => $color};
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    grid-column: 2 / span 2;
    grid-row: 1 / span 3;
  }
`

export const _Picture = styled(motion.create(Picture))``

export const Decoration = styled.div<{ $color?: string }>`
  position: relative;
  z-index: 1;
  grid-column: 1 / span 2;
  grid-row: 2 / span 3;
  background: ${({ $color }) => $color};
`
export const Wrapper = styled.div<{ $color?: string }>`
  position: relative;
  z-index: 3;
  grid-column: 1 / span 2;
  grid-row: 3 / span 3;
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  padding: ${pxToRem(32)} ${pxToRem(16)};
  background: ${({ $color }) => $color};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(40)};
    padding-block: ${pxToRem(80)};
    padding-inline: ${pxToRem(32)};
    grid-row: 3 / span 2;
  }
  @media ${mq(sizes.big)} {
    padding-inline: ${pxToRem(32)} ${pxToRem(80)};
  }
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.m375_h1}
  padding-block-end: ${pxToRem(24)};
  text-wrap: balance;
  @media ${mq(sizes.big)} {
    ${({ theme }) => theme.textStyles.d1440_h1}
  }
`

export const Content = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: space-between;
  }
  @media ${mq(sizes.big)} {
  }
`

export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_body}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
    width: 100%;
    max-width: ${pxToRem(564)};
  }
  @media ${mq(sizes.big)} {
    ${({ theme }) => theme.textStyles.d1440_bodyBig}
  }
`
export const _ActionButton = styled(ActionButton)`
  white-space: nowrap;
`

export const ContentBG = styled(motion.div)<{ $color?: string }>`
  position: relative;
  z-index: 2;
  grid-column: 1 / span 2;
  grid-row: 3 / span 3;
  display: flex;
  background: ${({ $color }) => $color};
  transform-origin: bottom left;
  @media ${mq(sizes.desktop)} {
    grid-row: 3 / span 2;
  }
`
